import { cB, cM } from "../../../_utils/cssr/index.mjs";
export default cB('checkbox', [cM('rtl', `
 direction: rtl;
 `)]);